import { render, staticRenderFns } from "./ChangeStoreNotice.vue?vue&type=template&id=46794976"
import script from "./ChangeStoreNotice.vue?vue&type=script&lang=js"
export * from "./ChangeStoreNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports